import { SKILL_SCORE_OPTIONS } from '@lms/shared'
import { Info } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

/** スキルチェックシート「ガイドライン」の評価時の考え方 */
const EVALUATION_POINTS = [
  '実際の業務行動を基準として評価してください',
  '単発の行動ではなく、「継続的に実践できているか」を基準として評価してください',
  '本人評価・上司評価共に率直に記入してください',
  '上司評価は、受講者本人の評価結果を参照せずに評価してください',
]

interface SkillCheckGuidelineProps {
  /** 研修ごとの補足（評価の目安など） */
  note?: string | null
}

export function SkillCheckGuideline({ note }: SkillCheckGuidelineProps) {
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-base">
          <Info className="h-4 w-4" />
          評価基準
        </CardTitle>
      </CardHeader>
      <CardContent className="grid gap-4 sm:grid-cols-2">
        <dl className="space-y-1 text-sm">
          {SKILL_SCORE_OPTIONS.map(({ score, label }) => (
            <div key={score} className="flex gap-3">
              <dt className="w-4 font-semibold tabular-nums">{score}</dt>
              <dd>{label}</dd>
            </div>
          ))}
        </dl>
        <ul className="list-disc space-y-1 pl-4 text-sm text-muted-foreground">
          {EVALUATION_POINTS.map((point) => (
            <li key={point}>{point}</li>
          ))}
        </ul>
        {note && <p className="whitespace-pre-wrap text-sm font-medium sm:col-span-2">{note}</p>}
      </CardContent>
    </Card>
  )
}
